import { Duration } from 'luxon';
import { useLayoutEffect, useRef, useState } from 'react';

export const TimeTrack = ({ duration, onSeek, timelineWidth }: { duration: Duration; onSeek: (seek: Duration) => void; timelineWidth: number }) => {
    const [timeUnitWidth, setTimeUnitWidth] = useState(700);
    const [timeUnits, setTimeUnits] = useState<string[]>([]);
    const trackRef = useRef<HTMLDivElement>(null);

    const onClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!e.currentTarget.parentElement) {
            return;
        }

        const x = e.clientX - e.currentTarget.parentElement.getBoundingClientRect().left;
        let position = x / e.currentTarget.parentElement.getBoundingClientRect().width;
        if (position < 0) {
            position = 0;
        }
        if (position > 1) {
            position = 1;
        }
        const seek = Duration.fromMillis(duration.toMillis() * position);
        onSeek(seek);
    };

    useLayoutEffect(() => {
        if (duration.toMillis() === 0 || !trackRef.current || !trackRef.current.parentElement) {
            return;
        }

        const width = trackRef.current.parentElement.getBoundingClientRect().width;
        let timeUnit = 1;
        let units = duration.as('minutes');
        let timeUnitWidth = width / units;
        for (timeUnit of [60, 30, 15, 10, 5, 2, 1, 0.5]) {
            units = duration.as('minutes') / timeUnit;
            timeUnitWidth = width / units;
            if (timeUnitWidth <= 500) {
                break;
            }
        }

        setTimeUnits(
            Array.from({ length: Math.ceil(units) }, (_, i) => {
                return Duration.fromObject({ minutes: i * timeUnit });
            }).map((unit) => {
                return unit.toFormat('hh:mm:ss');
            })
        );
        setTimeUnitWidth(width / units);
    }, [timelineWidth, duration, trackRef.current]);

    return (
        <div
            onClick={onClick}
            className="col-start-1 row-span-full grid auto-cols-(--v-time-unit-w) -ms-8 overflow-hidden ps-8 pe-px time-track"
            style={{ '--v-time-unit-w': `${timeUnitWidth}px` } as React.CSSProperties}
            ref={trackRef}
        >
            {timeUnits.map((timeUnit, index) => (
                <div key={index}>
                    <span className="w-fit block text-sm -translate-x-1/2 select-none">{timeUnit}</span>
                </div>
            ))}
        </div>
    );
};
